import React, { Component } from 'react'
import Select from 'react-select-plus'
import Modal from 'components/shared/Modal'
import { api } from 'app/modules/endUser/api'

import './style.styl'

const TYPES = ['STRING', 'NUMERIC', 'BOOLEAN', 'DATETIME', 'DATE']
const LABELS = {
  'STRING': 'Text',
  'NUMERIC': 'Number',
  'BOOLEAN': 'True/False',
  'DATETIME': 'Date/Time',
  'DATE': 'Date',
}

const ContactPropertyCreatorModal = ({ onClose }) => (
  <Modal
    onRequestClose={onClose}
    isOpen={true}
    style={ { content: { padding: 0, border: '1px solid transparent', background: 'none' }} }
  >
    <div className="contact-property-creator-modal">
      <ContactPropertyCreator onSave={onClose} />
    </div>
  </Modal>
)

class ContactPropertyCreator extends Component {
  state = {
    label: '',
    type: 'STRING',
    hasError: false,
    errorMsg: ''
  }

  updateLabel = event => {
    this.setState({
      label: event.target.value,
      hasError: false,
      errorMsg: ''
    })
  }

  updateType = option => {
    this.setState({
      type: option.value,
      hasError: false,
      errorMsg: ''
    })
  }

  typeOptions = () => {
    return TYPES.map(type => ({ label: LABELS[type], value: type }))
  }

  isValid = () => {
    return this.state.label.length && !!this.state.type
  }

  saveNewProperty = () => {
    if (!this.isValid) return
    const data = {
      displayName: this.state.label,
      name: this.state.label.split(' ').join('_'),
      type: this.state.type
    }

    api.addNewContactAttribute([data])
      .then(this.props.onSave)
      .catch(err => {
        this.setState({
          hasError: true,
          errorMsg: err.message
        })
      })
  }

  render() {
    return (
      <div className="contact-property-creator drift-form">
        <h3>Create New Contact Attribute</h3>
        {this.state.hasError && <span>{this.state.errorMsg}</span>}
        <label>Display Name</label>
        <input type="text" onChange={this.updateLabel} />
        <label>Attribute Type</label>
        <Select 
          options={this.typeOptions()}
          onChange={this.updateType}
          clearable={false}
          value={this.state.type}
        />
        <button className="drift-button drift-button-primary" disabled={!this.isValid} onClick={this.saveNewProperty}>
          Save New Property
        </button>
      </div>
    )
  }
}

export default ContactPropertyCreatorModal


// WEBPACK FOOTER //
// ./src/scripts/components/PropertyCreator/index.js